import React, {Component} from 'react'
import { Link } from 'react-router-dom'
import {
  Alert,
  Container,
  Row,
  Col,
  CardGroup,
  Card,
  CardBody,
  Button,
  Label,
  Input,
  InputGroup,
  InputGroupAddon
} from 'reactstrap'

import 'url-search-params-polyfill'
import Auth from '../../../modules/Auth'
import { post } from '../../../modules/API'


class ConfirmEmail extends Component {
  constructor(props) {
    super(props)

    this.state = {
      loaded: false,
      feedback: {
        type: 'info',
        message: ''
      }
    }
  }

  componentDidMount() {
    const urlParams = new URLSearchParams(window.location.search)
    const userAuthentication = post('users/confirm-changed-email', {
      username: urlParams.get('username'),
      token: urlParams.get('token')
    })

    userAuthentication.then(data => {
      this.setState({
        loaded: true,
        feedback: {
          type: 'info',
          message: 'Sie haben Ihre E-Mail-Adresse erfolgreich geändert.'
        }
      })
    }).catch(data => {
      this.setState({
        loaded: true,
        feedback: {
          type: 'danger',
          message: data.payload.message || 'Etwas ist schiefgegangen. Bitte versuchen Sie es erneut.'
        }
      })
    })
  }

  render() {
    return this.state.loaded && (
      <div className="app flex-row align-items-center">
        <Container>
          <Row className="justify-content-center">
            <Col>
              <div className="logo-standalone">
                <svg xmlns="http://www.w3.org/2000/svg" width="160" viewBox="0 0 166 41">
                  <path fill="#fff" d="M56.432 15.506v2.326h-5.5v2.564h5.23v2.327h-5.23v4.652h-2.65v-11.87h8.15zm9.9 10.545c-1.03.98-2.238 1.46-3.625 1.46s-2.533-.42-3.44-1.28c-.904-.85-1.357-2-1.357-3.44 0-1.43.46-2.58 1.384-3.43.922-.85 2.012-1.27 3.268-1.27 1.257 0 2.324.38 3.2 1.14.88.76 1.317 1.8 1.317 3.13v1.36h-6.66c.08.5.34.91.78 1.23.44.32.94.48 1.49.48.89 0 1.63-.3 2.21-.9l1.42 1.55zm-2.445-5.41c-.35-.29-.778-.44-1.282-.44s-.965.16-1.384.46c-.41.31-.66.72-.73 1.24h4.01c-.05-.54-.26-.96-.61-1.25zm9.832-.15c-.76 0-1.33.27-1.7.81-.38.54-.56 1.25-.56 2.13v3.96h-2.55v-9.14h2.54v1.21c.33-.37.74-.69 1.23-.95s.99-.39 1.5-.41l.01 2.4h-.49zm5.21-.4v4.09c0 .35.09.63.27.83.18.2.4.3.64.3.47 0 .87-.21 1.2-.64l.96 1.77c-.79.73-1.63 1.09-2.51 1.09-.88 0-1.62-.29-2.23-.86-.61-.57-.91-1.36-.91-2.36V20.1h-1.07v-1.84h1.07v-2.73h2.56v2.74h2.2v1.84h-2.2zm6.98 7.3h-2.55v-9.14h2.54v9.14zm-2.77-11.36c0-.42.14-.77.43-1.06.29-.29.64-.43 1.06-.43.42 0 .77.15 1.06.44.29.29.43.64.43 1.06 0 .42-.15.78-.44 1.06-.29.29-.64.44-1.06.44-.42 0-.78-.14-1.06-.43-.29-.29-.44-.64-.44-1.06zm10.97 4.87c-.41-.42-.91-.63-1.51-.63s-1.12.21-1.56.63c-.44.42-.66.99-.66 1.72s.21 1.31.63 1.76c.43.45.94.67 1.56.67.61 0 1.12-.22 1.53-.66.41-.44.61-1.03.61-1.76s-.21-1.31-.61-1.72zm.97 4.94c-.81.9-1.81 1.34-3 1.34s-2.2-.4-3.02-1.21c-.82-.81-1.23-1.89-1.23-3.24s.42-2.46 1.26-3.32c.84-.86 1.81-1.3 2.89-1.3s1.98.45 2.7 1.34v-1.21h2.54v7.96c0 .82-.14 1.54-.43 2.17-.29.64-.66 1.14-1.14 1.5-.94.75-2.05 1.12-3.33 1.12-.68 0-1.37-.11-2.08-.33-.71-.22-1.33-.53-1.86-.94l.98-1.92c.84.64 1.72.96 2.66.96.93 0 1.67-.23 2.21-.69.54-.46.81-1.2.81-2.2zm7.11-3.38v4.93h-2.55v-12.6h2.54v4.49c.77-.78 1.63-1.17 2.59-1.17.95 0 1.76.34 2.42 1.02.65.68.98 1.59.98 2.72v5.55h-2.55v-5c0-1.4-.52-2.1-1.55-2.1-.51 0-.95.18-1.33.55-.38.37-.57.91-.57 1.62zm16.06 4.93h-2.4v-1.11c-.66.83-1.47 1.24-2.44 1.24s-1.78-.28-2.44-.84c-.65-.56-.98-1.3-.98-2.24 0-.93.34-1.63 1.02-2.09.67-.46 1.6-.69 2.78-.69h1.9v-.05c0-.97-.52-1.46-1.55-1.46-.44 0-.91.09-1.4.27-.5.18-.91.39-1.25.65l-1.14-1.64c1.2-.87 2.57-1.31 4.11-1.31 1.11 0 2.01.27 2.71.83.7.55 1.05 1.43 1.05 2.63v5.82zm-2.57-3.48v-.44h-1.6c-1.02 0-1.53.32-1.53.95 0 .33.12.58.36.76.24.18.59.26 1.04.26.45 0 .85-.14 1.19-.41.34-.28.52-.65.52-1.11zm10.78-.73v-4.93h2.56v9.14h-2.57v-1.21c-.64.9-1.46 1.34-2.46 1.34s-1.85-.31-2.52-.94c-.68-.63-1.02-1.56-1.02-2.79v-5.54h2.56v4.98c0 1.41.51 2.11 1.54 2.11.51 0 .95-.18 1.32-.55.38-.37.56-.9.56-1.6zm10.86 3.53c-.67.55-1.51.82-2.53.82-.68 0-1.39-.12-2.12-.36-.74-.24-1.4-.6-1.99-1.07l1.12-1.59c.95.74 1.96 1.11 3.04 1.11.33 0 .59-.06.78-.19.19-.13.29-.3.29-.52 0-.21-.13-.41-.4-.59s-.65-.35-1.15-.51c-.51-.16-.89-.3-1.16-.41-.27-.11-.57-.28-.91-.49-.69-.43-1.04-1.07-1.04-1.91s.34-1.53 1.02-2.064c.67-.53 1.55-.8 2.63-.8 1.07 0 2.15.366 3.22 1.09l-.95 1.7c-.79-.545-1.58-.82-2.37-.82s-1.18.218-1.18.648c0 .24.12.42.37.56.25.137.66.296 1.24.477.58.18.99.32 1.23.42.24.1.53.25.87.45.632.39.95 1.03.95 1.93 0 .9-.33 1.623-.995 2.166zm2.69-.68c0-.42.14-.77.43-1.06.29-.29.64-.43 1.06-.43.42 0 .77.15 1.06.44.29.29.43.64.43 1.06 0 .42-.15.77-.44 1.06-.29.29-.65.44-1.06.44-.42 0-.78-.15-1.07-.43-.29-.29-.43-.64-.43-1.06zm5.91.12c-.85-.91-1.28-2.05-1.28-3.41 0-1.36.41-2.47 1.24-3.33.82-.86 1.79-1.3 2.9-1.3s2.01.39 2.71 1.17V14.8h2.55v12.6h-2.54v-1.21c-.71.894-1.61 1.34-2.69 1.34-1.08 0-2.04-.457-2.89-1.374zm1.95-1.5c.44.47.95.71 1.54.71.59 0 1.09-.24 1.5-.71.41-.47.62-1.07.62-1.81s-.21-1.36-.62-1.85c-.42-.49-.92-.74-1.52-.74s-1.12.25-1.55.75c-.43.5-.65 1.12-.65 1.85 0 .74.22 1.34.66 1.81zm16.5 1.42c-1.03.98-2.24 1.46-3.63 1.46-1.39 0-2.54-.42-3.44-1.28-.91-.85-1.36-2-1.36-3.44s.46-2.58 1.38-3.43c.92-.85 2.01-1.27 3.27-1.27 1.26 0 2.32.38 3.2 1.14.88.76 1.32 1.8 1.32 3.13v1.36h-6.66c.08.5.34.91.78 1.22.44.32.94.48 1.49.48.89 0 1.63-.3 2.21-.9l1.43 1.55zm-2.45-5.41c-.35-.29-.78-.44-1.28-.44-.51 0-.97.16-1.39.46-.42.31-.66.72-.73 1.24h4.01c-.06-.54-.26-.96-.61-1.25z"/>
                  <g fill="#3CB4E4">
                    <path d="M0 15.89l14.3 8.37V41L0 32.63V15.89zM27.08.04l14.3 8.37v16.73l-14.3-8.37V.04z" opacity=".2"/>
                    <path d="M7.44 31.91l13.25 7.76 13.25-7.76-13.25-7.75-13.25 7.75zm-2.02-3.73V12.99L18.39 5.4v15.18l-12.97 7.6z" opacity=".2"/>
                    <path d="M7.44 10.39l13.25 7.76 13.25-7.76-13.25-7.75-13.25 7.75zm15.59 26.62V21.83L36 14.24v15.18l-12.97 7.59z"/>
                  </g>
                </svg>
              </div>
            </Col>
          </Row>
          <Row className="justify-content-center">
            <Col>
              <CardGroup>
                <Card className="p-4">
                  <CardBody>
                    <h1>E-Mail-Adresse ändern</h1>
                    {this.state.feedback.message !== '' && <Alert color={this.state.feedback.type}>{this.state.feedback.message}</Alert>}
                    <Link to="/"><Button color="primary">Homepage</Button></Link>
                  </CardBody>
                </Card>
              </CardGroup>
            </Col>
          </Row>
        </Container>
      </div>
    )
  }
}

export default ConfirmEmail



// WEBPACK FOOTER //
// ./src/views/Pages/ConfirmEmail/ConfirmEmail.js